import { AbstractService } from '@uniqoders/sdk';
export default class SubscriptionService extends AbstractService {
    /**
     * Retrieves the logged user
     * @protected
     */
    retrieve() {
        return this.request('get', this.buildPath('/me/subscription'));
    }
}
